import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { PaymentsSessionCompaniesRepository } from '@app/domain/ports/payments-companies/payments-session-companies.repository';
import { PaymentsSessionCompany } from '@app/domain/models/payments-companies/payments-route-company';
import { GestorServicesResponseDto } from '@app/data/dtos/tpv/gestor.dto';
import { mapPaymentsSessionCompanies } from '@app/data/mappers/payments/payments-session-company.mapper';
import { silentBackgroundReadContext } from '@app/core/http/silent-background-read.context';

/** `GET /api/gestor/services/?polipay_account=<propia>` de fondo (sin modal genérico). */
@Injectable()
export class PaymentsSessionCompaniesRemoteDataSource extends PaymentsSessionCompaniesRepository {
  private readonly http = inject(HttpClient);

  override getOwnPaymentsCompanies(polipayAccount: string): Observable<PaymentsSessionCompany[]> {
    const root = (environment.apiUrl ?? '').replace(/\/+$/, '');
    return this.http
      .get<GestorServicesResponseDto>(`${root}/api/gestor/services/`, {
        params: new HttpParams().set('polipay_account', polipayAccount),
        context: silentBackgroundReadContext(),
      })
      .pipe(
        map(mapPaymentsSessionCompanies),
        catchError(() => of([])),
      );
  }
}
